var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._b({on:{"click":_vm.clickFn}},'el-button',_vm.options,false),[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }